module.exports = __webpack_public_path__ + "img/basket-shopping-simple.feaf494f.svg";